import { API_BASE_URL } from "@/config";
import IconCard from '@/components/CustomCard/IconCard.vue';
import CustomTable from "@/components/CustomTable/CustomTable.vue";
import { format_date } from '@/utils/date_formatter';

export default {
    name: "ViewWorkflowCustomers",
    components: {
        IconCard,
        CustomTable
    },
    data: () => ({
        total_applications: 0,
        completed_applications: 0,
        incomplete_applications: 0,
        total_customers: 0,
        total_services: 0,
        customers_current_page: 1,
        items_per_page: 10,
        columns: [
            { label: "Customer Name", key: "name_email" },
            { label: "Date Joined", key: "date_joined" },
            { label: "Last Login", key: "last_login" },
        ],
    }),
    computed: {
        workflow_id() {
            return this.$route.params.workflow_id;
        }
    },
    methods: {
        formatDate(date) {
            return format_date(date);
        },
        view_customer(customer_id) {
            this.$store.commit('set_workflow_id', this.workflow_id);
            this.$router.push({ name: 'view_customer_applications', params: { id: customer_id } });
        },
        fetch_workflow_stats() {
            const TOKEN = localStorage.getItem('token');
            const STATS_API = `${API_BASE_URL}/verify_api/workflow_management_api/workflow_stats_api/${this.workflow_id}`;
            
            $.ajax({
                url: STATS_API,
                method: 'GET',
                contentType: 'application/json',
                headers: {
                    Authorization: `Token ${TOKEN}`
                },
                beforeSend: () => {
                    Swal.fire({
                        text: 'Loading ...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                            Swal.showLoading();
                        }
                    });
                },
                success: (response) => {
                    Swal.close();
                    if (response.redirect) {
                        this.logout();
                        return;
                    }
                    const stats = response.data;
                    this.total_applications = stats.total_applications || 0;
                    this.completed_applications = stats.completed_applications || 0;
                    this.incomplete_applications = stats.incomplete_applications || 0;
                    this.total_customers = stats.total_customers || 0;
                    this.total_services = stats.total_services || 0;
                },
                error: () => {
                    Swal.close();
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Failed to fetch workflow statistics',
                        confirmButtonText: 'OK'
                    });
                }
            });
        },
        fetch_workflow_customers(page = 1, search = "") {
            const TOKEN = localStorage.getItem("token");
            return new Promise((resolve, reject) => {
            let url = `${API_BASE_URL}/verify_api/workflow_management_api/get_customers_in_workflow/${this.workflow_id}?page=${page}`;
            if (search) {
                url += `&search=${encodeURIComponent(search)}`;
            }
            $.ajax({
                url: url,
                method: "GET",
                dataType: "json",
                headers: {
                Authorization: `Token ${TOKEN}`,
                },
                success: function (data) {
                resolve({
                    count: data.count,
                    results: data.results,
                });
                },
                error: function (xhr, status, error) {
                reject(error);
                },
            });
            });
        },
    },
    mounted() {
        this.fetch_workflow_stats();
        this.fetch_workflow_customers();
    },
};
